'use client'

import Script from 'next/script'

import { configPublic } from '@src/config.public'

const { amplitude } = configPublic

export const AmplitudeWebExperiment = () => {
  return (
    // eslint-disable-next-line @next/next/no-before-interactive-script-outside-document
    <Script
      type="text/javascript"
      src={`https://cdn.amplitude.com/script/${amplitude.apiKey}.experiment.js`}
      strategy="beforeInteractive"
      async
    />
  )
}
